<template>
    <header
        :class="[
            headerActive ? 'header--active' : null,
            showSearch ? 'header--search-active' : null,
            showMenu ? 'header--hamburger-active' : null,
        ]"
        ref="header"
        class="header"
    >
        <div class="header__container-primary">
            <a :href="site.url">
                <slot name="brand-svg"/>
            </a>
            <nav class="header__navigation-container">
                <div class="header__secondary-link-container">
                    <a
                        v-for="item in menus.header_secondary.items"
                        :class="item.current ? 'header--current' : null"
                        :href="item.url"
                        v-text="item.name"
                        class="paragraph-02 header__sublink"
                    />
                </div>
                <div class="header__primary-link-container">
                    <a
                        v-for="item in menus.header_primary.items"
                        :class="item.current ? 'header--current' : null"
                        :href="item.url"
                        v-text="item.name"
                        class="header__link"
                    />
                    <button @click="toggleMenus('showSearch')" class="header__search-svg-container" type="button">
                        <slot name="search-icon"/>
                        <span
                            v-if="!showSearch"
                            v-text="'Search Button'"
                            class="access-hidden"
                        />
                        <span
                            v-if="showSearch"
                            v-text="'Close Search'"
                            class="access-hidden"
                        />
                        <span
                            v-else
                            v-text="'Open Search'"
                            class="access-hidden"
                        />
                    </button>
                    <button @click="toggleMenus('showMenu')" class="header__hamburger-container" type="button">
                        <span class="header__hamburger-bar-top"></span>
                        <span class="header__hamburger-bar-middle"></span>
                        <span class="header__hamburger-bar-bottom"></span>
                        <span
                            v-if="showMenu"
                            v-text="'Close Menu'"
                            class="access-hidden"
                        />
                        <span
                            v-else
                            v-text="'Open Menu'"
                            class="access-hidden"
                        />
                    </button>
                </div>
            </nav>
        </div>
        <div v-if="headerActive" class="header__container-secondary">
            <a :href="site.url">
                <slot name="brand-svg-horizontal"/>
            </a>
            <nav class="header__navigation-container">
                <div class="header__primary-link-container">
                    <a
                        v-for="item in menus.header_primary.items"
                        :class="item.current ? 'header--current' : null"
                        :href="item.url"
                        v-text="item.name"
                        class="header__link"
                    />
                    <button @click="toggleMenus('showSearch')" class="header__search-svg-container" type="button">
                        <slot name="search-icon-secondary"/>
                        <span
                            v-if="!showSearch"
                            v-text="'Search Button'"
                            class="access-hidden"
                        />
                        <span
                            v-if="showSearch"
                            v-text="'Close Search'"
                            class="access-hidden"
                        />
                        <span
                            v-else
                            v-text="'Open Search'"
                            class="access-hidden"
                        />
                    </button>
                    <button @click="toggleMenus('showMenu')" class="header__hamburger-container" type="button">
                        <span class="header__hamburger-bar-top"></span>
                        <span class="header__hamburger-bar-middle"></span>
                        <span class="header__hamburger-bar-bottom"></span>
                        <span
                            v-if="showMenu"
                            v-text="'Close Menu'"
                            class="access-hidden"
                        />
                        <span
                            v-else
                            v-text="'Open Menu'"
                            class="access-hidden"
                        />
                    </button>
                </div>
            </nav>
        </div>
        <div v-show="showSearch" class="header__modal">
            <div class="header__modal-container">
                <form class="header__modal-search-container" method="get" action="/">
                    <label for="search" class="access-hidden" v-text="'Search'"/>
                    <input
                        ref="input"
                        id="search"
                        class="header__modal-search-input"
                        type="search"
                        placeholder="Search"
                        name="search"
                        required
                    >
                </form>
            </div>
        </div>
        <nav v-if="showMenu" class="header__modal">
            <div class="header__modal-menu-container">
                <div class="header__modal-menu-inner">
                    <ul class="header__modal-list">
                        <li
                            v-for="item in menus.header_primary.items"
                            v-if="menus.header_primary.items"
                            class="header__modal-item"
                        >
                            <a
                                :href="item.url"
                                v-text="item.name"
                                :class=" item.current ? 'header--current' : null"
                                class="label-heading-01 header__modal-link"
                            />
                        </li>
                    </ul>
                    <hr class="horizontal-rule-03">
                    <div class="header__modal-sublink-container">
                        <a
                            v-for="item in menus.header_secondary.items"
                            :href="item.url"
                            v-text="item.name"
                            :class=" item.current ? 'header--current' : null"
                            class="paragraph-02 header__modal-sublink"
                        />
                    </div>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
    export default {
        name: 'BaseHeader',
        props: {
            site: {
                type: Object,
                required: true,
            },
            menus: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                threshold: 0.1,
                windowWidth: 0,
                showMenu: false,
                showSearch: false,
                rootMargin: '170px',
                headerActive: false,
            };
        },
        /* eslint-disable */
        methods: {
            enableScroll() {
                document.ontouchmove = true;
            },
            preventScroll() {
                document.ontouchmove = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                };
            },
            overflowTrigger(state) {
                return document.documentElement.classList[state]('no-overflow');
            },
            toggleMenuState(menu, showSearch, showMenu) {
                menu === `${showSearch}`
                    ? this[showMenu] = false
                    : menu === `${showMenu}`
                    ? this[showSearch] = false
                    : menu;
            },
            toggleMenus(menu) {
                this[menu] = !this[menu];

                if (this[menu]) {
                // this.preventScroll();
                    if (document.documentElement.classList.contains('search--disabled')) {
                        this.showSearch = false;
                    } else {
                        this.overflowTrigger('add');
                        this.toggleMenuState(menu, 'showSearch', 'showMenu')
                    }
                } else {
                    this.enableScroll();
                    this.overflowTrigger('remove');
                }
            },
            getWindowWidth() {
                this.windowWidth = document.documentElement.clientWidth;
            },
            intersect(entries) {
                const entry = entries.filter(({target}) => {
                    return target === this.$refs.header;
                });

                if (entry[0].intersectionRatio < this.threshold) {
                    this.headerActive = true;
                } else {
                    this.headerActive = false;
                }
            },
        },
        watch: {
            windowWidth() {
                if (this.windowWidth > 1024) {
                    this.showMenu = false;
                    this.overflowTrigger('remove');
                }
            },
            showSearch() {
                if (this.showSearch) {
                   this.$refs.input.autofocus = true;
                }
            }
        },
        mounted() {
            const io = new IntersectionObserver(
                this.intersect,
                {
                    rootMargin: this.rootMargin,
                    threshold: [this.threshold]
                },
            )

            io.POLL_INTERVAL = 100;
            io.observe(this.$refs.header);

            this.$nextTick(() => {
                window.addEventListener('resize', this.getWindowWidth);
                this.getWindowWidth();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
        },
    };
</script>



// WEBPACK FOOTER //
// BaseHeader.vue?3c6993f0